module.exports = __webpack_public_path__ + "static/media/home2_.95c93f8a.svg";